// src/main.jsx — V6 ENTERPRISE FINAL (Storage Guardian removido)
// ═══════════════════════════════════════════════════════════════════════════
// 🔥 V6: STORAGE GUARDIAN ELIMINADO — IndexedDB ya maneja logs y storage
// 🔥 V6: Código limpio, sin monkey-patches, igual a Airbnb/Notion/Zillow
// 🔥 V6: Render directo sin interceptar localStorage
// ═══════════════════════════════════════════════════════════════════════════
//
// Arquitectura de almacenamiento actual:
//   📦 IndexedDB (propzyn_db)
//   ├── user_data    → Datos del usuario (LocalStrategy V9)
//   ├── sync_logs    → Logs de conflicto y sync (ConflictResolver V4 + SyncManager V16)
//   └── files        → Archivos base64 en chunks
//
//   📦 localStorage (solo tokens y preferencias)
//   ├── auth_user
//   ├── userEmail
//   ├── current_company
//   └── data_strategy
//
// ═══════════════════════════════════════════════════════════════════════════

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./contexts/AuthProvider";
import { ThemeProvider } from "./contexts/ThemeContext";
import { NotificationsProvider } from "./contexts/NotificationsContext";
import "./index.css";

// ═══════════════════════════════════════════════════════════════════════════
// 🚀 RENDER
// ═══════════════════════════════════════════════════════════════════════════

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <ThemeProvider>
        <NotificationsProvider>
          <App />
        </NotificationsProvider>
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>
);